import "../../css/Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-social">
        <a
          href="https://github.com/kaustubhharapanahalli"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="GitHub"
        >
          GitHub
        </a>
        <a
          href="https://linkedin.com/in/kmhalli"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          LinkedIn
        </a>
        <a
          href="https://scholar.google.com/citations?user=51Dqq8kAAAAJ&hl=en"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Google Scholar"
        >
          Google Scholar
        </a>
      </div>
      <p>&copy; {currentYear} Kaustubh Harapanahalli</p>
    </footer>
  );
};

export default Footer;
